import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"

import { projectColorPalette, projectColorSwatches } from "@/components/ProjectCoverEditor/ProjectColorPalette.ts"
import { CheckmarkMedium } from "@/icons/Icons.ts"

import type { ProjectCoverModel } from "@/components/ProjectCoverEditor/ProjectCoverModel.ts"


export const ColorPicker = observer((props: {
  model: ProjectCoverModel
  canEditProject: boolean
}) => {
  const selectedColor = props.model.color.get()
  return (
    <ColorGrid>
      {projectColorSwatches.map((swatch, index) => (
        <ColorSwatch
          key={swatch}
          color={projectColorPalette[swatch]}
          selected={selectedColor === swatch}
          canEditProject={props.canEditProject}
          onClick={() => props.canEditProject && props.model.selectColor(swatch)}
          role="button"
          aria-label={`Select color ${index + 1}`}
        >
          {selectedColor === swatch && (
            <CheckmarkContainer>
              <CheckmarkMedium />
            </CheckmarkContainer>
          )}
        </ColorSwatch>
      ))}
    </ColorGrid>
  )
})

const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 16px;

  width: 100%;
  padding: 0;
`

const ColorSwatch = styled.div<{
  color: string
  selected: boolean
  canEditProject: boolean
}>`
  position: relative;
  aspect-ratio: 1;
  width: 100%;

  border: 3px solid transparent;
  border-radius: var(--border-radius-12);
  background-color: ${props => props.color};

  cursor: pointer;
  transition: all 0.2s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: center;

  pointer-events: ${props => props.canEditProject ? "auto" : "none"};

  &:hover {
    transform: scale(1.05);
    border-color: var(--text-color-20);
  }

  &:focus-visible {
    outline: ${props => props.selected ? "none" : "2px solid var(--main-color)"};
    outline-offset: -2px;
  }

  &:active {
    transform: scale(0.95);
  }
`

const CheckmarkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 20px;

  color: white;
  filter: drop-shadow(0 1px 6px rgb(0 0 0 / 30%));
`
